import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { DefaultAutocomplete } from "../../../../../../common/components/default_autocomplete";
import { DefaultDatePickerInput } from "../../../../../../common/components/default_date_picker_input";
import { MaskedInput } from "../../../../../../common/components/masked_inputs/masked_input";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";

import CascateList from "../../../../../../common/components/cascate_list";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  tipoPesquisa: number;
  valorPesquisa: string | null;
  idFuncionario: number | null;
  dataCadastro: Date | null;
  dataPagamento: Date | null;
  numero: string | null;
  funcionarios: FuncionarioDropDown[];
  onTipoPesquisaChange: (novoTipoPesquisa: number) => void;
  onValorPesquisaChange: (novoValorPesquisa: string | null) => void;
  onFuncionarioChange: (novoIdFuncionario: number | null) => void;
  onDataCadastroChange: (novaData: Date | null) => void;
  onDataPagamentoChange: (novaData: Date | null) => void;
  onNumeroChange: (novoNumero: string | null) => void;
  onClear: () => void;
};

export const Header = ({
  tipoPesquisa,
  valorPesquisa,
  idFuncionario,
  dataCadastro,
  dataPagamento,
  numero,
  funcionarios,
  onTipoPesquisaChange,
  onValorPesquisaChange,
  onFuncionarioChange,
  onDataCadastroChange,
  onDataPagamentoChange,
  onNumeroChange,
  onClear,
}: Props) => {
  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <FormControl size="small" sx={{ width: "275px" }}>
                <InputLabel id="modulo-dashboard" size="small">Pesquisar por</InputLabel>
                <Select
                  size="small"
                  labelId="modulo-dashboard"
                  label="Pesquisar por"
                  value={tipoPesquisa}
                  onChange={(e) => onTipoPesquisaChange(Number(e.target.value))}>
                  <MenuItem value={1}>Descrição</MenuItem>
                </Select>
              </FormControl>

              <div className="w-full">
                <DefaultInput
                  label="Pesquisar"
                  name="search_by_value"
                  value={valorPesquisa ?? ""}
                  onChangeValue={onValorPesquisaChange} />
              </div>
            </div>

            <DefaultAutocomplete
              label="Funcionário"
              options={funcionarios}
              getOptionLabel={x => x.nome}
              getOptionKey={x => x.idFuncionario}
              value={funcionarios.find(f => f.idFuncionario === idFuncionario)}
              onChange={f => onFuncionarioChange(f?.idFuncionario ?? null)} />

            <DefaultDatePickerInput
              label="Data cadastro"
              value={dataCadastro}
              onChange={dt => onDataCadastroChange(dt)} />

            <DefaultDatePickerInput
              label="Data Pagamento"
              value={dataPagamento}
              onChange={dt => onDataPagamentoChange(dt)} />

            <MaskedInput
              name="numero"
              label="Numero"
              mask="0000000"
              maskPlaceholder="_______"
              value={numero}
              onChange={onNumeroChange} />

          </div>

          <div className="w-full flex justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={onClear}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}